/**
 * Comparaison de textes pour les recherches faites dans le navigateur.
 *
 * <p>Une recherche locale comparait jusqu'ici `toLowerCase()` contre
 * `toLowerCase()` : « eleve » ne trouvait pas « Élève », et « احمد » ne
 * trouvait pas « أحمد ». Personne ne tape les accents ni les hamzas dans un
 * champ de recherche — un filtre qui les exige passe pour un filtre vide.</p>
 *
 * <p>Une seule règle, donc, partagée par tous les écrans : deux copies
 * finiraient par ne pas trouver le même élève selon la page ouverte.</p>
 */

// Signes combinants latins (accents), puis arabes : voyelles brèves, chadda,
// hamza et madda détachées par la décomposition NFD, alif suscrit, tatweel.
const MARKS = /[\u0300-\u036f\u064b-\u065f\u0670\u0640]/g;

/** Forme de comparaison : sans casse, sans accents, sans signes diacritiques. */
export function normalizeSearchText(value: unknown): string {
  if (value === null || value === undefined) return '';
  return `${value}`.normalize('NFD').replace(MARKS, '').toLowerCase().trim();
}

/**
 * Le terme figure-t-il dans ces textes ? Un terme vide laisse tout passer :
 * c'est l'état « aucun filtre », pas une recherche sans résultat.
 *
 * <p>Les textes sont joints par une espace avant la comparaison : « prénom nom »
 * doit trouver une personne dont les deux vivent dans deux champs.</p>
 */
export function matchesSearch(term: string | null | undefined, ...texts: unknown[]): boolean {
  const needle = normalizeSearchText(term);
  if (!needle) return true;
  const haystack = texts.map(normalizeSearchText).filter(Boolean).join(' ');
  return haystack.includes(needle);
}
